import { normalizeBranding, brandingStyle } from '../../../shared/event-branding'
export { normalizeBranding, brandingStyle }
export function activeEvent(game) {
    return (game.seasons || []).find(s => s.id == game.active_season_id) || null;
}
